import { useCallback } from "react";
import { useDispatch } from "react-redux";
import { useAppSelector } from "stores/hooks";
import { markLocalSearch } from "stores/local-search/localSearchSlice";
import { selectSearchAddressResult } from "stores/save-search/saveSearchSlice";
import { SearchInitialState } from "stores/search/types";
export const useMarkLocalSearchUpdate = () => {
  const dispatch = useDispatch();
  const searchAddress = useAppSelector(selectSearchAddressResult);
  return useCallback((search: SearchInitialState["state"]) => {
    dispatch(markLocalSearch({
      locationData: {
        bounds: search.bounds,
        shortName: search.shortName,
        longName: search.longName,
        placeId: search.placeId,
        placeType: search.placeType,
        lat: search.lat,
        lng: search.lng,
        isSearchingInMap: search.isSearchingInMap,
        Location: search.Location,
        propertyConfigTypeId: null,
        page: search.page
      },
      dateRangeData: {
        startDate: search.startDate,
        endDate: search.endDate,
        noOfDays: search.noOfDays
      },
      guestDetails: {
        adultCount: search.adultCount,
        childrenCount: search.childrenCount,
        petAllowed: search.petAllowed,
        childAllowed: search.childAllowed,
        suitableChild: search.suitableChild,
        numberOfGuest: search.numberOfGuest
      },
      searchAddressResult: {
        address_components: searchAddress?.address_components || []
      }
    }));
  }, [dispatch]);
};